import { InterfaceItem } from '@core/models/interface-item.model';
import { Estimate } from '@interfaces/Estimate';

const prefix = 'SYNC_CRM';
export const EstimateCrmSyncItems: InterfaceItem<Estimate>[] = [
  {
    key: 'projectManager',
    labelKey: `${prefix}.PROJECT_MANAGER`
  },
  {
    key: 'clientName',
    labelKey: `${prefix}.CLIENT`
  },
  {
    key: 'clientContactName',
    labelKey: `${prefix}.CLIENT_CONTACT`
  },
  {
    key: 'projectModelCode',
    labelKey: `${prefix}.PROJECT_TEMPLATE`
  },
  {
    key: 'departmentCode',
    labelKey: `${prefix}.DEPARTMENTCODE`
  },
  {
    key: 'currencyCode',
    labelKey: `${prefix}.CURRENCYCODE`
  },
  {
    key: 'companyCode',
    labelKey: `${prefix}.COMPANYCODE`
  }
];
